import UserInfo from "@/models/api/user/UserInfo";
import { VueRouter } from 'vue-router/types/router';
import { Store } from 'vuex'
import Vue from 'vue'
import { VueCookies } from 'vue-cookies';

class Helper {
    logoff(vue: Vue): void {
        this.logoffSRC(vue.$store, vue.$router, vue.$cookies);
    }

    logoffSRC(store: Store<any>, router: VueRouter, cookies: VueCookies): void {
        console.log("LogOff called!");

        cookies.set("selectedAssociation", "");

        store.commit('setUserInfo', new UserInfo());
        store.commit('addOverlay');

        //push({ name: "Login" })
        router.push({ name: "/" }).then(() => {
            window.location.reload();
        }).catch(() => {
            window.location.reload();
        });
    }
}

export const UserHelper = new Helper();
